/**
 * @fileoverview gRPC-Web generated client stub for mycargo.projects.erp.api.v1.services
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.12.4
// source: projects/erp/service/api/v1/services/special_orders.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')

var projects_erp_service_api_v1_model_special_order_pb = require('./special_order_pb.js')
const proto = {};
proto.mycargo = {};
proto.mycargo.projects = {};
proto.mycargo.projects.erp = {};
proto.mycargo.projects.erp.api = {};
proto.mycargo.projects.erp.api.v1 = {};
proto.mycargo.projects.erp.api.v1.services = require('./special_orders_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.mycargo.projects.erp.api.v1.services.SpecialOrdersClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.mycargo.projects.erp.api.v1.services.SpecialOrdersPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mycargo.projects.erp.api.v1.services.ListSpecialOrdersRequest,
 *   !proto.mycargo.projects.erp.api.v1.services.ListSpecialOrdersResponse>}
 */
const methodDescriptor_SpecialOrders_ListSpecialOrders = new grpc.web.MethodDescriptor(
  '/mycargo.projects.erp.api.v1.services.SpecialOrders/ListSpecialOrders',
  grpc.web.MethodType.UNARY,
  proto.mycargo.projects.erp.api.v1.services.ListSpecialOrdersRequest,
  proto.mycargo.projects.erp.api.v1.services.ListSpecialOrdersResponse,
  /**
   * @param {!proto.mycargo.projects.erp.api.v1.services.ListSpecialOrdersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.mycargo.projects.erp.api.v1.services.ListSpecialOrdersResponse.deserializeBinary
);


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.ListSpecialOrdersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mycargo.projects.erp.api.v1.services.ListSpecialOrdersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mycargo.projects.erp.api.v1.services.ListSpecialOrdersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mycargo.projects.erp.api.v1.services.SpecialOrdersClient.prototype.listSpecialOrders =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.SpecialOrders/ListSpecialOrders',
      request,
      metadata || {},
      methodDescriptor_SpecialOrders_ListSpecialOrders,
      callback);
};


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.ListSpecialOrdersRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mycargo.projects.erp.api.v1.services.ListSpecialOrdersResponse>}
 *     Promise that resolves to the response
 */
proto.mycargo.projects.erp.api.v1.services.SpecialOrdersPromiseClient.prototype.listSpecialOrders =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.SpecialOrders/ListSpecialOrders',
      request,
      metadata || {},
      methodDescriptor_SpecialOrders_ListSpecialOrders);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mycargo.projects.erp.api.v1.services.GetSpecialOrderRequest,
 *   !proto.mycargo.projects.erp.api.v1.model.SpecialOrder>}
 */
const methodDescriptor_SpecialOrders_GetSpecialOrder = new grpc.web.MethodDescriptor(
  '/mycargo.projects.erp.api.v1.services.SpecialOrders/GetSpecialOrder',
  grpc.web.MethodType.UNARY,
  proto.mycargo.projects.erp.api.v1.services.GetSpecialOrderRequest,
  projects_erp_service_api_v1_model_special_order_pb.SpecialOrder,
  /**
   * @param {!proto.mycargo.projects.erp.api.v1.services.GetSpecialOrderRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  projects_erp_service_api_v1_model_special_order_pb.SpecialOrder.deserializeBinary
);


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.GetSpecialOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mycargo.projects.erp.api.v1.model.SpecialOrder)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mycargo.projects.erp.api.v1.model.SpecialOrder>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mycargo.projects.erp.api.v1.services.SpecialOrdersClient.prototype.getSpecialOrder =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.SpecialOrders/GetSpecialOrder',
      request,
      metadata || {},
      methodDescriptor_SpecialOrders_GetSpecialOrder,
      callback);
};


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.GetSpecialOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mycargo.projects.erp.api.v1.model.SpecialOrder>}
 *     Promise that resolves to the response
 */
proto.mycargo.projects.erp.api.v1.services.SpecialOrdersPromiseClient.prototype.getSpecialOrder =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.SpecialOrders/GetSpecialOrder',
      request,
      metadata || {},
      methodDescriptor_SpecialOrders_GetSpecialOrder);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mycargo.projects.erp.api.v1.services.CreateSpecialOrderRequest,
 *   !proto.mycargo.projects.erp.api.v1.model.SpecialOrder>}
 */
const methodDescriptor_SpecialOrders_CreateSpecialOrder = new grpc.web.MethodDescriptor(
  '/mycargo.projects.erp.api.v1.services.SpecialOrders/CreateSpecialOrder',
  grpc.web.MethodType.UNARY,
  proto.mycargo.projects.erp.api.v1.services.CreateSpecialOrderRequest,
  projects_erp_service_api_v1_model_special_order_pb.SpecialOrder,
  /**
   * @param {!proto.mycargo.projects.erp.api.v1.services.CreateSpecialOrderRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  projects_erp_service_api_v1_model_special_order_pb.SpecialOrder.deserializeBinary
);


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.CreateSpecialOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mycargo.projects.erp.api.v1.model.SpecialOrder)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mycargo.projects.erp.api.v1.model.SpecialOrder>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mycargo.projects.erp.api.v1.services.SpecialOrdersClient.prototype.createSpecialOrder =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.SpecialOrders/CreateSpecialOrder',
      request,
      metadata || {},
      methodDescriptor_SpecialOrders_CreateSpecialOrder,
      callback);
};


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.CreateSpecialOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mycargo.projects.erp.api.v1.model.SpecialOrder>}
 *     Promise that resolves to the response
 */
proto.mycargo.projects.erp.api.v1.services.SpecialOrdersPromiseClient.prototype.createSpecialOrder =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.SpecialOrders/CreateSpecialOrder',
      request,
      metadata || {},
      methodDescriptor_SpecialOrders_CreateSpecialOrder);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mycargo.projects.erp.api.v1.services.UpdateSpecialOrderRequest,
 *   !proto.mycargo.projects.erp.api.v1.model.SpecialOrder>}
 */
const methodDescriptor_SpecialOrders_UpdateSpecialOrder = new grpc.web.MethodDescriptor(
  '/mycargo.projects.erp.api.v1.services.SpecialOrders/UpdateSpecialOrder',
  grpc.web.MethodType.UNARY,
  proto.mycargo.projects.erp.api.v1.services.UpdateSpecialOrderRequest,
  projects_erp_service_api_v1_model_special_order_pb.SpecialOrder,
  /**
   * @param {!proto.mycargo.projects.erp.api.v1.services.UpdateSpecialOrderRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  projects_erp_service_api_v1_model_special_order_pb.SpecialOrder.deserializeBinary
);


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.UpdateSpecialOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mycargo.projects.erp.api.v1.model.SpecialOrder)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mycargo.projects.erp.api.v1.model.SpecialOrder>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mycargo.projects.erp.api.v1.services.SpecialOrdersClient.prototype.updateSpecialOrder =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.SpecialOrders/UpdateSpecialOrder',
      request,
      metadata || {},
      methodDescriptor_SpecialOrders_UpdateSpecialOrder,
      callback);
};


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.UpdateSpecialOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mycargo.projects.erp.api.v1.model.SpecialOrder>}
 *     Promise that resolves to the response
 */
proto.mycargo.projects.erp.api.v1.services.SpecialOrdersPromiseClient.prototype.updateSpecialOrder =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.SpecialOrders/UpdateSpecialOrder',
      request,
      metadata || {},
      methodDescriptor_SpecialOrders_UpdateSpecialOrder);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mycargo.projects.erp.api.v1.services.DeleteSpecialOrderRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_SpecialOrders_DeleteSpecialOrder = new grpc.web.MethodDescriptor(
  '/mycargo.projects.erp.api.v1.services.SpecialOrders/DeleteSpecialOrder',
  grpc.web.MethodType.UNARY,
  proto.mycargo.projects.erp.api.v1.services.DeleteSpecialOrderRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.mycargo.projects.erp.api.v1.services.DeleteSpecialOrderRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.DeleteSpecialOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mycargo.projects.erp.api.v1.services.SpecialOrdersClient.prototype.deleteSpecialOrder =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.SpecialOrders/DeleteSpecialOrder',
      request,
      metadata || {},
      methodDescriptor_SpecialOrders_DeleteSpecialOrder,
      callback);
};


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.DeleteSpecialOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.mycargo.projects.erp.api.v1.services.SpecialOrdersPromiseClient.prototype.deleteSpecialOrder =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.SpecialOrders/DeleteSpecialOrder',
      request,
      metadata || {},
      methodDescriptor_SpecialOrders_DeleteSpecialOrder);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mycargo.projects.erp.api.v1.services.ListSpecialOrderPaymentsRequest,
 *   !proto.mycargo.projects.erp.api.v1.services.ListSpecialOrderPaymentsResponse>}
 */
const methodDescriptor_SpecialOrders_ListSpecialOrderPayments = new grpc.web.MethodDescriptor(
  '/mycargo.projects.erp.api.v1.services.SpecialOrders/ListSpecialOrderPayments',
  grpc.web.MethodType.UNARY,
  proto.mycargo.projects.erp.api.v1.services.ListSpecialOrderPaymentsRequest,
  proto.mycargo.projects.erp.api.v1.services.ListSpecialOrderPaymentsResponse,
  /**
   * @param {!proto.mycargo.projects.erp.api.v1.services.ListSpecialOrderPaymentsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.mycargo.projects.erp.api.v1.services.ListSpecialOrderPaymentsResponse.deserializeBinary
);


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.ListSpecialOrderPaymentsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mycargo.projects.erp.api.v1.services.ListSpecialOrderPaymentsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mycargo.projects.erp.api.v1.services.ListSpecialOrderPaymentsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mycargo.projects.erp.api.v1.services.SpecialOrdersClient.prototype.listSpecialOrderPayments =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.SpecialOrders/ListSpecialOrderPayments',
      request,
      metadata || {},
      methodDescriptor_SpecialOrders_ListSpecialOrderPayments,
      callback);
};


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.ListSpecialOrderPaymentsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mycargo.projects.erp.api.v1.services.ListSpecialOrderPaymentsResponse>}
 *     Promise that resolves to the response
 */
proto.mycargo.projects.erp.api.v1.services.SpecialOrdersPromiseClient.prototype.listSpecialOrderPayments =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.SpecialOrders/ListSpecialOrderPayments',
      request,
      metadata || {},
      methodDescriptor_SpecialOrders_ListSpecialOrderPayments);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mycargo.projects.erp.api.v1.services.CreateSpecialOrderPaymentRequest,
 *   !proto.mycargo.projects.erp.api.v1.model.SpecialOrderPayment>}
 */
const methodDescriptor_SpecialOrders_CreateSpecialOrderPayment = new grpc.web.MethodDescriptor(
  '/mycargo.projects.erp.api.v1.services.SpecialOrders/CreateSpecialOrderPayment',
  grpc.web.MethodType.UNARY,
  proto.mycargo.projects.erp.api.v1.services.CreateSpecialOrderPaymentRequest,
  projects_erp_service_api_v1_model_special_order_pb.SpecialOrderPayment,
  /**
   * @param {!proto.mycargo.projects.erp.api.v1.services.CreateSpecialOrderPaymentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  projects_erp_service_api_v1_model_special_order_pb.SpecialOrderPayment.deserializeBinary
);


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.CreateSpecialOrderPaymentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mycargo.projects.erp.api.v1.model.SpecialOrderPayment)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mycargo.projects.erp.api.v1.model.SpecialOrderPayment>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mycargo.projects.erp.api.v1.services.SpecialOrdersClient.prototype.createSpecialOrderPayment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.SpecialOrders/CreateSpecialOrderPayment',
      request,
      metadata || {},
      methodDescriptor_SpecialOrders_CreateSpecialOrderPayment,
      callback);
};


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.CreateSpecialOrderPaymentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mycargo.projects.erp.api.v1.model.SpecialOrderPayment>}
 *     Promise that resolves to the response
 */
proto.mycargo.projects.erp.api.v1.services.SpecialOrdersPromiseClient.prototype.createSpecialOrderPayment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.SpecialOrders/CreateSpecialOrderPayment',
      request,
      metadata || {},
      methodDescriptor_SpecialOrders_CreateSpecialOrderPayment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mycargo.projects.erp.api.v1.services.UpdateSpecialOrderPaymentRequest,
 *   !proto.mycargo.projects.erp.api.v1.model.SpecialOrderPayment>}
 */
const methodDescriptor_SpecialOrders_UpdateSpecialOrderPayment = new grpc.web.MethodDescriptor(
  '/mycargo.projects.erp.api.v1.services.SpecialOrders/UpdateSpecialOrderPayment',
  grpc.web.MethodType.UNARY,
  proto.mycargo.projects.erp.api.v1.services.UpdateSpecialOrderPaymentRequest,
  projects_erp_service_api_v1_model_special_order_pb.SpecialOrderPayment,
  /**
   * @param {!proto.mycargo.projects.erp.api.v1.services.UpdateSpecialOrderPaymentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  projects_erp_service_api_v1_model_special_order_pb.SpecialOrderPayment.deserializeBinary
);


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.UpdateSpecialOrderPaymentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mycargo.projects.erp.api.v1.model.SpecialOrderPayment)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mycargo.projects.erp.api.v1.model.SpecialOrderPayment>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mycargo.projects.erp.api.v1.services.SpecialOrdersClient.prototype.updateSpecialOrderPayment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.SpecialOrders/UpdateSpecialOrderPayment',
      request,
      metadata || {},
      methodDescriptor_SpecialOrders_UpdateSpecialOrderPayment,
      callback);
};


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.UpdateSpecialOrderPaymentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mycargo.projects.erp.api.v1.model.SpecialOrderPayment>}
 *     Promise that resolves to the response
 */
proto.mycargo.projects.erp.api.v1.services.SpecialOrdersPromiseClient.prototype.updateSpecialOrderPayment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.SpecialOrders/UpdateSpecialOrderPayment',
      request,
      metadata || {},
      methodDescriptor_SpecialOrders_UpdateSpecialOrderPayment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mycargo.projects.erp.api.v1.services.DeleteSpecialOrderPaymentRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_SpecialOrders_DeleteSpecialOrderPayment = new grpc.web.MethodDescriptor(
  '/mycargo.projects.erp.api.v1.services.SpecialOrders/DeleteSpecialOrderPayment',
  grpc.web.MethodType.UNARY,
  proto.mycargo.projects.erp.api.v1.services.DeleteSpecialOrderPaymentRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.mycargo.projects.erp.api.v1.services.DeleteSpecialOrderPaymentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.DeleteSpecialOrderPaymentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mycargo.projects.erp.api.v1.services.SpecialOrdersClient.prototype.deleteSpecialOrderPayment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.SpecialOrders/DeleteSpecialOrderPayment',
      request,
      metadata || {},
      methodDescriptor_SpecialOrders_DeleteSpecialOrderPayment,
      callback);
};


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.DeleteSpecialOrderPaymentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.mycargo.projects.erp.api.v1.services.SpecialOrdersPromiseClient.prototype.deleteSpecialOrderPayment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.SpecialOrders/DeleteSpecialOrderPayment',
      request,
      metadata || {},
      methodDescriptor_SpecialOrders_DeleteSpecialOrderPayment);
};


module.exports = proto.mycargo.projects.erp.api.v1.services;
